import { render, staticRenderFns } from "./SalesClientsLineChart.vue?vue&type=template&id=45cce472&scoped=true"
import script from "./SalesClientsLineChart.vue?vue&type=script&lang=js"
export * from "./SalesClientsLineChart.vue?vue&type=script&lang=js"
import style0 from "./SalesClientsLineChart.vue?vue&type=style&index=0&id=45cce472&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cce472",
  null
  
)

export default component.exports